import React, { memo } from 'react';
interface ConfidentialitateProps {
  navigate: (page: string) => void;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-3060">
      <h2 className="text-lg font-semibold text-light-1 mb-3" data-id="element-3061">{title}</h2>
      <div className="space-y-3" data-id="element-3062">{children}</div>
    </section>;
}
export function Confidentialitate({
  navigate
}: ConfidentialitateProps) {
  return <div className="min-h-screen bg-dark-1" data-id="element-3063">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-3064">
        <h1 className="text-3xl sm:text-4xl font-bold text-light-1 mb-2" data-id="element-3065">
          Politica de confidentialitate
        </h1>
        <p className="text-sm text-light-4 mb-12" data-id="element-3066">
          Ultima actualizare: 29 martie 2026
        </p>

        <div className="space-y-10 text-light-2 text-sm leading-relaxed" data-id="element-3067">
          <Section title="1. Operatorul de date" data-id="element-3068">
            <p data-id="element-3069">
              Operatorul datelor dvs. cu caracter personal este echipa Izio
              (&quot;Izio&quot;, &quot;noi&quot;, &quot;nostru&quot;).
            </p>
            <p data-id="element-3070">
              Pentru orice intrebari privind prelucrarea datelor personale, ne
              puteti contacta la: contact@izio.ro.
            </p>
          </Section>

          <Section title="2. Ce date colectam" data-id="element-3071">
            <h3 className="text-light-1 font-medium mt-2" data-id="element-3072">
              Date de cont (la inregistrare):
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3073">
              <li data-id="element-3074">Nume si prenume</li>
              <li data-id="element-3075">Adresa de email</li>
              <li data-id="element-3076">Parola (stocata criptat, niciodata in text clar)</li>
              <li data-id="element-3077">
                Sau, daca alegeti autentificarea sociala: numele si adresa de
                email furnizate de Google, Facebook sau LinkedIn — nu importam
                alte date din profilul dvs. social
              </li>
            </ul>

            <h3 className="text-light-1 font-medium mt-4" data-id="element-3078">
              Date de profil de chirias (completate voluntar de dvs.):
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3079">
              <li data-id="element-3080">Informatii personale: prenume, nume, an nastere, ocupatie</li>
              <li data-id="element-3081">
                Preferinte de locuinta: buget, oras, zona, tip locuinta, etaj,
                an constructie, facilitati esentiale
              </li>
              <li data-id="element-3082">Fotografie de profil (incarcata de dvs.)</li>
              <li data-id="element-3083">
                Stil de viata: fumat, animale de companie, statut cuplu,
                biografie
              </li>
            </ul>
            <p data-id="element-3084">
              <strong className="text-light-1" data-id="element-3085">Nu colectam</strong> copii ale
              actelor de identitate, date bancare, date medicale sau alte date
              sensibile.
            </p>

            <h3 className="text-light-1 font-medium mt-4" data-id="element-3086">
              Date din aplicari la anunturi:
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3087">
              <li data-id="element-3088">
                Datele de contact ale proprietarului introduse de dvs. (email,
                telefon, nume) si link-ul anuntului — stocate pentru istoricul
                aplicarilor dvs.
              </li>
            </ul>

            <h3 className="text-light-1 font-medium mt-4" data-id="element-3089">
              Date din formularul de contact:
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3090">
              <li data-id="element-3091">Nume, email, mesaj</li>
            </ul>

            <h3 className="text-light-1 font-medium mt-4" data-id="element-3092">
              Date colectate automat:
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3093">
              <li data-id="element-3094">Adresa IP, tipul browserului, sistemul de operare</li>
              <li data-id="element-3095">Paginile vizitate si actiunile efectuate pe Platforma</li>
              <li data-id="element-3096">
                Cookie-uri de sesiune si, cu consimtamantul dvs., cookie-uri
                analitice
              </li>
            </ul>
          </Section>

          <Section title="3. Scopurile si temeiul juridic al prelucrarii" data-id="element-3097">
            <div className="overflow-x-auto" data-id="element-3098">
              <table className="w-full border-collapse mt-2" data-id="element-3099">
                <thead data-id="element-3100">
                  <tr className="border-b border-dark-4" data-id="element-3101">
                    <th className="text-left py-2 pr-4 text-light-1 font-medium" data-id="element-3102">
                      Scop
                    </th>
                    <th className="text-left py-2 text-light-1 font-medium" data-id="element-3103">
                      Temei juridic (GDPR)
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-dark-4/50" data-id="element-3104">
                  <tr data-id="element-3105">
                    <td className="py-2 pr-4" data-id="element-3106">
                      Crearea si gestionarea contului
                    </td>
                    <td className="py-2" data-id="element-3107">
                      Executarea contractului (Art. 6(1)(b))
                    </td>
                  </tr>
                  <tr data-id="element-3108">
                    <td className="py-2 pr-4" data-id="element-3109">
                      Afisarea profilului de chirias catre proprietari
                    </td>
                    <td className="py-2" data-id="element-3110">
                      Executarea contractului (Art. 6(1)(b))
                    </td>
                  </tr>
                  <tr data-id="element-3111">
                    <td className="py-2 pr-4" data-id="element-3112">
                      Gestionarea istoricului de aplicari
                    </td>
                    <td className="py-2" data-id="element-3113">
                      Executarea contractului (Art. 6(1)(b))
                    </td>
                  </tr>
                  <tr data-id="element-3114">
                    <td className="py-2 pr-4" data-id="element-3115">
                      Trimiterea notificarilor prin email
                    </td>
                    <td className="py-2" data-id="element-3116">
                      Executarea contractului (Art. 6(1)(b))
                    </td>
                  </tr>
                  <tr data-id="element-3117">
                    <td className="py-2 pr-4" data-id="element-3118">
                      Raspunsul la mesajele de contact
                    </td>
                    <td className="py-2" data-id="element-3119">Interes legitim (Art. 6(1)(f))</td>
                  </tr>
                  <tr data-id="element-3120">
                    <td className="py-2 pr-4" data-id="element-3121">
                      Analiza utilizarii Platformei (cookie-uri analitice)
                    </td>
                    <td className="py-2" data-id="element-3122">Consimtamant (Art. 6(1)(a))</td>
                  </tr>
                  <tr data-id="element-3123">
                    <td className="py-2 pr-4" data-id="element-3124">
                      Securitatea Platformei si prevenirea fraudelor
                    </td>
                    <td className="py-2" data-id="element-3125">Interes legitim (Art. 6(1)(f))</td>
                  </tr>
                  <tr data-id="element-3126">
                    <td className="py-2 pr-4" data-id="element-3127">
                      Respectarea obligatiilor legale
                    </td>
                    <td className="py-2" data-id="element-3128">Obligatie legala (Art. 6(1)(c))</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Section>

          <Section title="4. Cui transmitem datele dvs." data-id="element-3129">
            <p data-id="element-3130">Datele dvs. pot fi transmise catre:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3131">
              <li data-id="element-3132">
                <strong className="text-light-1" data-id="element-3133">
                  Alti utilizatori ai Platformei
                </strong>{' '}
                — proprietarii pot vedea profilul dvs. de chirias daca acesta
                este setat ca public
              </li>
              <li data-id="element-3134">
                <strong className="text-light-1" data-id="element-3135">
                  Furnizori de servicii tehnice (imputerniciti)
                </strong>
                :
                <ul className="list-disc pl-6 mt-1 space-y-1" data-id="element-3136">
                  <li data-id="element-3137">Vercel Inc. (SUA) — gazduire si infrastructura</li>
                  <li data-id="element-3138">Neon Inc. (SUA) — baza de date</li>
                  <li data-id="element-3139">
                    Resend Inc. (SUA) — trimitere email-uri tranzactionale
                  </li>
                  <li data-id="element-3140">Google LLC (SUA) — autentificare sociala (optionala)</li>
                  <li data-id="element-3141">
                    Meta Platforms Inc. (SUA) — autentificare sociala
                    (optionala)
                  </li>
                  <li data-id="element-3142">
                    LinkedIn Corp. (SUA) — autentificare sociala (optionala)
                  </li>
                </ul>
              </li>
              <li data-id="element-3143">
                <strong className="text-light-1" data-id="element-3144">Autoritati publice</strong> —
                cand legislatia ne obliga
              </li>
            </ul>
            <p data-id="element-3145">
              Nu vindem si nu cedam datele dvs. catre terti in scopuri
              comerciale sau publicitare.
            </p>
          </Section>

          <Section title="5. Transferuri internationale de date" data-id="element-3146">
            <p data-id="element-3147">
              Unii dintre furnizorii nostri de servicii sunt stabiliti in
              Statele Unite ale Americii. Transferurile de date catre SUA sunt
              efectuate in baza:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3148">
              <li data-id="element-3149">
                Cadrului UE-SUA privind protectia datelor (EU-US Data Privacy
                Framework) — pentru furnizorii certificati (Google, Meta,
                LinkedIn)
              </li>
              <li data-id="element-3150">
                Clauzelor contractuale standard ale Comisiei Europene — pentru
                ceilalti furnizori
              </li>
            </ul>
          </Section>

          <Section title="6. Durata de stocare a datelor" data-id="element-3151">
            <ul className="list-disc pl-6 space-y-1" data-id="element-3152">
              <li data-id="element-3153">
                <strong className="text-light-1" data-id="element-3154">Date de cont si profil</strong>
                : pe durata existentei contului + 30 de zile dupa solicitarea de
                stergere (pentru a permite recuperarea in caz de eroare)
              </li>
              <li data-id="element-3155">
                <strong className="text-light-1" data-id="element-3156">Date din aplicari</strong>: 12
                luni de la data aplicarii, dupa care sunt sterse automat
              </li>
              <li data-id="element-3157">
                <strong className="text-light-1" data-id="element-3158">
                  Date din formularul de contact
                </strong>
                : 6 luni de la rezolvarea solicitarii
              </li>
              <li data-id="element-3159">
                <strong className="text-light-1" data-id="element-3160">Cookie-uri de sesiune</strong>:
                pana la deconectare sau expirarea sesiunii
              </li>
              <li data-id="element-3161">
                <strong className="text-light-1" data-id="element-3162">Cookie-uri analitice</strong>:
                conform setarilor furnizorului de analiza (de obicei 12-26 luni)
              </li>
            </ul>
          </Section>

          <Section title="7. Drepturile dvs." data-id="element-3163">
            <p data-id="element-3164">Conform GDPR, beneficiati de urmatoarele drepturi:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3165">
              <li data-id="element-3166">
                <strong className="text-light-1" data-id="element-3167">Dreptul de acces</strong> (Art.
                15) — puteti solicita o copie a datelor pe care le detinem
                despre dvs.
              </li>
              <li data-id="element-3168">
                <strong className="text-light-1" data-id="element-3169">Dreptul la rectificare</strong>{' '}
                (Art. 16) — puteti solicita corectarea datelor inexacte;
                majoritatea datelor de profil le puteti modifica direct din cont
              </li>
              <li data-id="element-3170">
                <strong className="text-light-1" data-id="element-3171">Dreptul la stergere</strong>{' '}
                (Art. 17) — puteti solicita stergerea contului si a datelor
                asociate (&quot;dreptul de a fi uitat&quot;)
              </li>
              <li data-id="element-3172">
                <strong className="text-light-1" data-id="element-3173">
                  Dreptul la restrictionarea prelucrarii
                </strong>{' '}
                (Art. 18)
              </li>
              <li data-id="element-3174">
                <strong className="text-light-1" data-id="element-3175">
                  Dreptul la portabilitatea datelor
                </strong>{' '}
                (Art. 20) — puteti solicita exportul datelor dvs. intr-un format
                structurat
              </li>
              <li data-id="element-3176">
                <strong className="text-light-1" data-id="element-3177">Dreptul la opozitie</strong>{' '}
                (Art. 21) — puteti va opune prelucrarii bazate pe interes
                legitim
              </li>
              <li data-id="element-3178">
                <strong className="text-light-1" data-id="element-3179">
                  Dreptul de a retrage consimtamantul
                </strong>{' '}
                (Art. 7) — pentru cookie-urile analitice, in orice moment prin
                bannerul de cookie-uri, fara a afecta legalitatea prelucrarii
                anterioare
              </li>
            </ul>
            <p data-id="element-3180">
              Pentru exercitarea acestor drepturi, trimiteti un email la
              contact@izio.ro. Vom raspunde in termen de 30 de zile
              calendaristice.
            </p>
          </Section>

          <Section title="8. Cookie-uri si tehnologii similare" data-id="element-3181">
            <p data-id="element-3182">
              Folosim cookie-uri pentru a asigura functionarea Platformei si, cu
              consimtamantul dvs., pentru analiza utilizarii.
            </p>
            <h3 className="text-light-1 font-medium mt-2" data-id="element-3183">
              Categorii de cookie-uri:
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3184">
              <li data-id="element-3185">
                <strong className="text-light-1" data-id="element-3186">Esentiale</strong> — necesare
                functionarii Platformei: autentificare, securitate, retinerea
                preferintelor de consimtamant. Nu necesita consimtamant.
              </li>
              <li data-id="element-3187">
                <strong className="text-light-1" data-id="element-3188">Analitice</strong> — ne ajuta
                sa intelegem cum este utilizata Platforma (pagini vizitate,
                durata sesiunii). Necesita consimtamantul dvs.
              </li>
              <li data-id="element-3189">
                <strong className="text-light-1" data-id="element-3190">Functionale</strong> — permit
                memorarea unor preferinte suplimentare de interfata. Necesita
                consimtamantul dvs.
              </li>
            </ul>
            <p data-id="element-3191">
              Puteti gestiona sau retrage consimtamantul pentru cookie-uri in
              orice moment prin link-ul &quot;Setari cookie-uri&quot; din
              subsolul paginii. Preferintele dvs. sunt stocate local in
              browserul dvs., nu in contul dvs. Izio.
            </p>
          </Section>

          <Section title="9. Securitatea datelor" data-id="element-3192">
            <p data-id="element-3193">
              Implementam masuri tehnice si organizatorice adecvate pentru
              protejarea datelor dvs., inclusiv:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3194">
              <li data-id="element-3195">Criptarea datelor in tranzit (HTTPS/TLS)</li>
              <li data-id="element-3196">Stocarea securizata a parolelor prin hashing (bcrypt)</li>
              <li data-id="element-3197">Accesul la baza de date restrictionat si monitorizat</li>
              <li data-id="element-3198">Infrastructura gazduita pe platforme certificate SOC 2</li>
            </ul>
          </Section>

          <Section title="10. Copiii" data-id="element-3199">
            <p data-id="element-3200">
              Platforma nu se adreseaza persoanelor sub 18 ani. Nu colectam
              intentionat date personale de la minori. Daca descoperim ca am
              colectat date de la un minor, le vom sterge prompt.
            </p>
          </Section>

          <Section title="11. Modificari ale Politicii" data-id="element-3201">
            <p data-id="element-3202">
              Ne rezervam dreptul de a actualiza aceasta Politica. Modificarile
              semnificative vor fi comunicate prin email sau notificare pe
              Platforma inainte de intrarea in vigoare. Continuarea utilizarii
              Platformei dupa aceasta data constituie acceptarea Politicii
              actualizate.
            </p>
          </Section>

          <Section title="12. Plangeri" data-id="element-3203">
            <p data-id="element-3204">
              Daca considerati ca prelucrarea datelor dvs. incalca GDPR, aveti
              dreptul de a depune o plangere la:
            </p>
            <ul className="list-none space-y-1" data-id="element-3205">
              <li data-id="element-3206">
                <strong className="text-light-1" data-id="element-3207">
                  Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu
                  Caracter Personal (ANSPDCP)
                </strong>
              </li>
              <li data-id="element-3208">B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, Bucuresti</li>
              <li data-id="element-3209">Email: anspdcp@dataprotection.ro</li>
              <li data-id="element-3210">Website: www.dataprotection.ro</li>
            </ul>
          </Section>

          <Section title="13. Contact" data-id="element-3211">
            <p data-id="element-3212">Pentru orice intrebari privind aceasta Politica:</p>
            <ul className="list-none space-y-1" data-id="element-3213">
              <li data-id="element-3214">Email: contact@izio.ro</li>
            </ul>
          </Section>
        </div>
      </div>
    </div>;
}